import React, { PropsWithChildren } from "react";

const PlusIcon = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      fill="none"
      viewBox="0 0 18 17"
      {...props}>
      <path
        fill="#522398"
        d="M16.906 7.719h-6.875V.844A.37.37 0 009.687.5H8.313a.339.339 0 00-.344.344v6.875H1.094a.339.339 0 00-.344.343v1.376c0 .214.129.343.344.343h6.875v6.875c0 .215.129.344.343.344h1.376a.339.339 0 00.343-.344V9.781h6.875a.339.339 0 00.344-.344V8.063a.37.37 0 00-.344-.344z"></path>
    </svg>
  );
};

export default React.memo(PlusIcon);
